import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const HorizonalGridContainerStyle = styled(Box)(({ theme }) => ({
  display: 'grid',
  columnGap: theme.spacing(1),
  rowGap: theme.spacing(1.5),
  width: '100%',
  paddingBottom: theme.spacing(6),
  boxSizing: 'border-box',
  gridAutoFlow: 'column',
  gridTemplateRows: 'repeat(2, auto)',
  gap: 2,
  overflowX: 'auto',
  overflowY: 'hidden',
}));

export const GridSlideWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  width: '100%',
}));

export const ListContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isHorizonLayout',
})<{ isHorizonLayout?: boolean }>(({ theme, isHorizonLayout }) => ({
  background: theme.palette.common.white,
  padding: theme.spacing(0),
  width: 300,
  boxSizing: 'border-box',
  ...(isHorizonLayout && {
    overflow: 'visible',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),
}));
